import Vue from 'vue'

export default {
  state: {
    sidebar: {
      collapsed: false,
      pinned: false
    }
  },
  getters: {
    sidebarCollapsed: state => {
      return state.sidebar.collapsed
    },
    sidebarPinned: state => {
      return state.sidebar.pinned
    }
  },
  mutations: {
    setCollapseSidebar: (state, value) => {
      state.sidebar.collapsed = Boolean(Number(value))
    },
    setPinSidebar: (state, value) => {
      state.sidebar.pinned = Boolean(Number(value))
    },
    toggleCollapseSidebar: (state) => {
      state.sidebar.collapsed = !state.sidebar.collapsed
      Vue.$cookies.set('sidebarCollapsed', Number(state.sidebar.collapsed))
    },
    togglePinSidebar: (state) => {
      state.sidebar.pinned = !state.sidebar.pinned
      Vue.$cookies.set('sidebarPinned', Number(state.sidebar.pinned))
    }
  },
  actions: {
    setCollapseSidebar: ({ commit }, value) => {
      commit('setCollapseSidebar', value)
    },
    setPinSidebar: ({ commit }, value) => {
      commit('setPinSidebar', value)
    },
    toggleCollapseSidebar: ({ commit }) => {
      commit('toggleCollapseSidebar')
    },
    togglePinSidebar: ({ commit }) => {
      commit('togglePinSidebar')
    }
  }
}
